module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Trials")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoInd"
  }, [_vm._v("By Sean Ian O’Meidhir and Connal Braginsky")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoInd"
  }, [_vm._v("Crossing Nüwa: Book Two")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("With the help of technomage and hacker Theo, rare snake shifter Robbie escaped his mother and clan, who planned to use him as breeding stock. While still working to break through the conditioning and mind control of his past, Robbie is enjoying exploring a new relationship with the worldlier Theo.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But their fight isn’t over yet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A trip to his aunt’s house for Thanksgiving is highjacked by political intrigue, leaving the couple wondering who their friends really are. They cannot help but be drawn into larger plots while trying to find justice for Robbie at his mother’s trial. When clan rivalries turn deadly, they’ll need their allies—and each other—more than ever.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0